//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { recordRelationHandler, loadRelation, deleteRelation } from "@/assets/api/dataBase.js";
import {utils} from "@/assets/utils/utils.js";
import Alert from '@/components/alert/index'
import text from '@/assets/api/text.json'
export default {
    components: {
        Alert
    },
    // 项目管理
    data() {
        return {
            addNum: false,
            lastNameText: '姓名不能为空！',
            indexs: '',
            items: [],
            isRelationType: false,
            isName: false,
            isCardId: '',
            identitype: '',
            otherSpouseNameText: '请填写！',
            otherSpouseNameList: [],
            isSpouseName: false,
            relationList: [{   
                value: "00",
                label: "请选择",
                relationType: '0',
                userName: '',
                mobile: '',
                idNo: '',
                identity: '0',
                spouseName:'',
                isActiveFlag: false,
                isSpouseName: false,
                isName: false,
                isRelationType: false,
                isidentity: false,
                tagger: 1,
                isMobile: false,
                mobileTxt: '',
                isOtherSpouseName: false,
                otherSpouseName: "",
            }],
            dataList: null,
            num:0,
            isChangeName: false,
            changeNameTxt: '',
            isAllRrquridSuccess: false,
            isCheckBox: false,
            checked01: false,
            textList:[],
            productCode:localStorage.getItem('productCode')
        }
    },
    filters: {
        spouceFilter(value) {
            if(value == '7'){
                return value = '朋友'
            }else if(value == '8'){
                return value = '亲戚'
            }else if(value == '6'){
                return value = '合伙人'
            }else{
                return ''
            }
        },
    },
    mounted(){
        this.init()
    },
    methods:{
        isActiveFData(item,index){
            const arr = []
            this.otherSpouseNameList.map(i =>{
                arr.push(i.userName)
            })
            if(item.activeFlag == "1" && item.spouseNames !="" && arr.indexOf(item.spouseName)==-1){
                this.relationList[index].isActiveFlag = true
            }else{
                this.relationList[index].isActiveFlag = false
            }

        },
        verNoticeBox(){
            if(this.productCode === '6000' && this.checked01 === false){
                this.isCheckBox = true;
                this.isAllSuccess()
            }else{
                this.isCheckBox = false;
                this.isAllSuccess()
            }
        },
        // 授权
        spaceEventCheckBox(e){
            e.currentTarget.previousElementSibling.focus()
            let aa = e.currentTarget.previousElementSibling.name
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa]
        },
        mobileBlur(item){
            if(item.mobile.length<11){
                item.mobile = ''
                item.isMobile = true
                item.mobileTxt = '手机号码位数不够！'
            }else{
                item.isMobile = false
            }
        },
        init(){
            text.map((item, index) => {
                if(this.productCode === item.code){
                    this.textList = item;
                    this.getlist()
                    return
                }
                return
            });
            
        },
        getlist(){
            loadRelation({}).then(result => {
                if (result.responseCode === "000000") {
                    let retsult = result.responseData
                    if(retsult.relationList.length>0){
                        this.relationList = retsult.relationList
                        this.otherSpouseNameList = []
                        const arr = []
                        const arr1 = []
                        this.relationList.forEach((item,index)=>{
                            // 获取配偶姓名和下标
                            arr1.push({'data':item.spouseName,'index':index})
                            // 存储配偶姓名，避免实施修改
                            item.spouseNames = item.spouseName
                            // 配偶姓名的下拉选项
                            if(this.productCode == '6000'){
                                if( ['2', '3', '5'].indexOf(item.identity) > -1 && item.userName !="" ){
                                    this.otherSpouseNameList.push(item)
                                }else{
                                    item.isActiveFlag = false
                                }
                            }else if(this.productCode == '7000'){
                                if( ['8', '9'].indexOf(item.relationType) == -1 && item.userName !="" ){
                                    this.otherSpouseNameList.push(item)
                                }else{
                                    item.isActiveFlag = false
                                }
                            }
                        })
                        // 是否重复
                        this.otherSpouseNameList.map((item,index) =>{
                            arr.push(item.userName)
                        })
                        arr1.map((k,y)=>{
                            if(arr.indexOf(k.data)>-1){
                                this.relationList[y].isActiveFlag = false
                            }else{
                                this.relationList[y].isActiveFlag = true
                            }
                        })
                    }
                }
            });
            
        },
        isAllSuccess(){
            let item = this.relationList
            let isAllS = 0
            for(let i=0; i<item.length; i++){
                if(this.productCode === '6000' && ( item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isidentity || item[i].isOtherSpouseName)){
                    isAllS = isAllS+1
                }else if(this.productCode === '7000' && ( item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isOtherSpouseName)){
                    isAllS = isAllS+1
                }
            }

            if(isAllS>0 || this.isCheckBox){
                return this.isAllRrquridSuccess = true
            }else{
                return this.isAllRrquridSuccess = false
            }

        },
        identityChange(item,index){
            if(item.identity && item.identity == '0'){
                this.relationList[index].isidentity = true
                this.isAllSuccess()
            }else{
                this.relationList[index].isidentity = false
                this.isAllSuccess()
            }
        },
        relationTypeChange(item,index){
            if(item.relationType && item.relationType == '0'){
                this.relationList[index].isRelationType = true
                this.isAllSuccess()
            }else{
                this.relationList[index].isRelationType = false
                this.isAllSuccess()
            }
        },
        userNameChange(item,index){
            let reg = /^[\u4e00-\u9fa5]+$/
            if( item.userName &&!reg.test(item.userName)){
                this.lastNameText = '姓名请输入中文！'
                this.relationList[index].isName= true
            }else{
                if(!item.userName){
                    this.relationList[index].isName= true
                    this.isAllSuccess()
                }else{
                    if(this.productCode === '7000'){
                        // productcode 7000
                        this.otherSpouseNameList = []
                        //选择了 8 9 之外的需要在relationList添加人名
                        this.relationList.forEach((item,index)=>{
                            if( ['8', '9'].indexOf(item.relationType) == -1 && item.userName !="" ){
                                this.otherSpouseNameList.push(item)
                            }
                        })
                        if(['8', '9'].indexOf(item.relationType) == -1){
                            // 如果选择的不是8 9，那就隐藏请填写的input
                            this.relationList[index].isOtherSpouseName = false
                            this.isAllSuccess()
                        }
                        
                        console.log('7000.otherSpouseNameList',this.otherSpouseNameList);
                    }
                    this.relationList[index].isName = false
                    this.isAllSuccess()
                }
            }
        },
        identityChangeList(item, index){
            //productcode 6000
            if(this.productCode == '6000'){
                this.otherSpouseNameList = []
                this.relationList.forEach((item,index)=>{
                    if( ['2', '3', '5'].indexOf(item.identity) > -1 && item.userName !="" ){
                        this.otherSpouseNameList.push(item)
                    }
                })
                if(['6', '7', '8'].indexOf(item.identity) == -1){
                    // 如果选择的不是合伙人配偶、朋友配偶、亲戚配偶，那就隐藏请填写的input
                    this.relationList[index].isOtherSpouseName = false
                    this.isAllSuccess()
                }
                console.log('6000.otherSpouseNameList',this.otherSpouseNameList);
            }
            
        },
        otherSpouseNameChange(item,index){
            let reg = /^[\u4e00-\u9fa5]+$/
            if( item.otherSpouseName && !reg.test(item.otherSpouseName)){
                this.otherSpouseNameText = '请填写中文！'
                this.relationList[index].isOtherSpouseName= true
            }else{
                if(!item.otherSpouseName){
                    this.relationList[index].isOtherSpouseName= true
                    this.isAllSuccess()
                }else{
                    this.relationList[index].isOtherSpouseName = false
                    this.isAllSuccess()
                }
            }
        },
        //选择此其他贷款义务人或相关人士配偶姓名
        spouseNameChange(item,index){
            if(!item.spouseName){
                 this.relationList[index].isSpouseName= true
                this.isAllSuccess()
            }else{
                this.relationList[index].isSpouseName = false
                this.isAllSuccess()
            
            }
        },
        addItem() {
            if(this.productCode == '7000'){
                if(this.relationList.length < 20){
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1', 
                        isMobile: false,
                        mobileTxt: ''
                    })
                    this.addNum = false
                }else{
                    this.addNum = true
                }
            }else{
                if(this.relationList.length < 10){
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1', 
                        isMobile: false,
                        mobileTxt: ''
                    })
                    this.addNum = false
                }else{
                    this.addNum = true
                }
            }
        },
        affirm(item,index){
            this.$refs.alert.showAlert();
            this.items = item
            this.indexs = index
        },
        cancelInfo(){
            this.$refs.alert.closeAlert()
        },

        deleteItem(item,indexs) {
            if(item.tagger){
                this.relationList.splice(indexs,1);
                this.otherSpouseNameList = []
                this.relationList.forEach((item,index)=>{
                    if( ['2', '3', '5'].indexOf(item.identity) > -1 && item.userName !="" ){
                        this.otherSpouseNameList.push(item)
                    }
                })
                this.cancelInfo()
            }else{
                deleteRelation(item).then(result => {
                    if (result.responseCode === "000000") {
                        let retsult = result.responseData
                        this.relationList = retsult.relationList
                        this.cancelInfo()
                        this.init()
                    }
                })
                
            }
            if(this.productCode == '7000'){
                if(this.relationList.length<20){
                    this.addNum = false
                }
            }else{
                if(this.relationList.length<10){
                    this.addNum = false
                }
            }
        },
        next(){
            this.verNoticeBox()
            this.isAllRrquridSuccess = false
            for( let i=0;i<this.relationList.length;i++){
                 this.relationTypeChange(this.relationList[i],i)
                this.userNameChange(this.relationList[i],i)
                this.identityChange(this.relationList[i],i)
                if(['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 || (this.productCode === '7000' && (this.relationList[i].relationType == '8'|| this.relationList[i].relationType == '9'))){
                    this.spouseNameChange(this.relationList[i],i)
                }  
                if(['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 && this.relationList[i].spouseName == "其他"){
                    this.otherSpouseNameChange(this.relationList[i],i)
                }
               
            }
            let statusInfo = this.isAllSuccess()
            if(!statusInfo){
                this.pass()
            }
        },
        pass(){
            const param = [];
            this.relationList.map((item,index)=>{
                param.push({
                    id : item.id,
                    mobile : item.mobile,
                    userName : item.userName,
                    relationType : item.relationType,
                    identity : item.identity,
                    spouseName : item.spouseName!="其他"?item.spouseName:item.otherSpouseName
                })
            })
            recordRelationHandler({relationList:param,type1006:this.checked01}).then(result => {
                if (result.responseCode === "000000") {
                    let fbCode = result.responseData.fbCode
                    let fbMessage = result.responseData.fbMessage
                    let messageInfo = utils.routerJump.returnUrl(fbCode);
                    let url = messageInfo.url
                    this.$router.push({
                        path:url,
                        query:{           
                            code:fbCode,
                            fbMessage:fbMessage,
                        }
                    })
                }
            })  
        },
        btnBack(){
            this.$router.push({
                path:"/stepDescription"
            });
        }

    }
}



// WEBPACK FOOTER //
// ./src/view/linkPeople.vue